import { Box, Typography } from "@mui/material";

interface Props {
	url: string | null;
	title?: string;
}

export const PdfViewer = ({ url, title }: Props) => {
	if (!url) {
		return (
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					height: "100%",
				}}
			>
				<Typography variant="body2" color="text.secondary">
					Select a document to preview
				</Typography>
			</Box>
		);
	}

	return (
		<Box
			component="iframe"
			src={url}
			title={title ?? "Roll layout document"}
			sx={{ width: "100%", height: "100%", border: "none" }}
		/>
	);
};
